<template>
  <div class="chart-container">
    <div class="x-axis-title">{{ xAxisName }}</div>
    <div class="chart-content">
      <div class="chart-area">
        <OssImg class="chart-image" src="images/home4.png" :style="{ width: imgWidth,maxHeight:'80%' }"  alt="" />
      </div>
    </div>

    <div class="y-axis">
      <div v-for="(tick, index) in yTicks" :key="index" class="y-tick">
        <span class="y-tick-label">{{ tick }}w</span>
      </div>
      <div class="y-axis-title">{{ yAxisName }}</div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineExpose } from "vue";

// 配置数据
const yTicks = [30, 20, 10, 1];
const xAxisName = "2018jul 1";
const yAxisName = "2025jul 1";
const imgWidth = ref(0);

const animate = () => {
  imgWidth.value = "85%";
};

defineExpose({
  animate,
});
</script>

<style lang="scss" scoped>
.chart-container {
  display: flex;
  width: 100%;
  height: 90%;
  min-height: 13rem;
  max-width: 600px;
  font-family: Arial, sans-serif;
  position: relative;
}

.y-axis {
  width: 80px;
  height: 80%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
  position: relative;
}

.y-tick {
  display: flex;
  align-items: center;
  position: relative;
}

.y-tick-label {
  font-size: 0.875rem;
  color: #bbbbbb;
  width: 30px;
  text-align: right;
}

.y-tick-line {
  flex-grow: 1;
  height: 1px;
  background-color: #eee;
}

.y-axis-title {
  position: absolute;
  bottom: -25px;
  left: 0;
  width: 100%;
  text-align: center;
  font-size: 0.875rem;
  color: #bbbbbb;
  white-space: nowrap;
}

.chart-content {
  flex-grow: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.x-axis-title {
  text-align: center;
  font-size: 0.875rem;
  color: #bbbbbb;
  position: absolute;
  bottom: 20px;
  left: 0.5rem;
}

.chart-area {
  flex-grow: 1;
  position: relative;
  margin-left: 10px;

  .chart-image {
    position: absolute;
    bottom: 3rem;
    top:-10px;
    margin-left: 8%;
    transition: width 2s ease;
  }
}
</style>
